import get from 'lodash.get';

const getCurrentButtonPresetVersion = (state) =>
  get(state, 'ws.site.meta.customization.currentButtonPresetVersion', null);

export default getCurrentButtonPresetVersion;
